export default __webpack_public_path__ + "static/media/1.21e8ca7a.jpg";